import { render, staticRenderFns } from "./BackStore.vue?vue&type=template&id=78a15f6b&"
import script from "./BackStore.vue?vue&type=script&lang=js&"
export * from "./BackStore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports